// листинг в каталоге

import { ref , reactive , nextTick } from 'vue';
import { createApp , watch } from 'vue/dist/vue.esm-bundler';
import { createPinia } from "pinia";
import { useContextStore } from '../../../../assets/site/js/contextStore.js'

function initStoreListPage(){

    const el = document.querySelector( '#store-list' );

    if( el ){
        createApp(
            {
                setup(){

                    const contextStore = useContextStore();
                    const view_mode = ref( 'list' );
                    const map = ref( null );
                    const view_list = ref( null );
                    const view_map = ref( null );

                    let city = findCityBySlug( contextStore.data.city_slug );
                    let objectManager;
                    let myMap;

                    function findCityBySlug( slug ){
                        return Object.values( contextStore.data.city ).find( item => item.slug === slug );
                    }

                    function applyBounds(){
                        myMap.setBounds( myMap.geoObjects.getBounds() )
                            .then(
                                () => {
                                    if( objectManager.objects.getLength() === 1 ){
                                        myMap.setZoom( 14 );
                                    }
                                }
                            )
                    }

                    function setView( data ){

                        view_mode.value = data;

                        if( data === 'map' ){
                            view_list.value.style.display='none';
                            view_map.value.style.display='block';
                            myMap.container.fitToViewport();
                            applyBounds();
                        }else if( data === 'list' ){
                            view_map.value.style.display='none';
                            view_list.value.style.display='block';
                        }

                    }

                    ymaps.ready( initMap );

                    function initMap(){

                        objectManager = new ymaps.ObjectManager(
                            {
                                clusterize : true ,
                                gridSize : 160 ,
                                zoomMargin : 100 ,
                                clusterDisableClickZoom : false
                            }
                        );
                        objectManager.objects.options.set( 'preset' , 'islands#nightShoppingIcon' );
                        objectManager.clusters.options.set( 'preset' , 'islands#nightClusterIcons' );

                        let lon_max = 0;
                        let lon_min = 0;
                        let lat_max = 0;
                        let lat_min = 0;

                        Object.values( contextStore.data.shop ).forEach(
                            item => {

                                lon_max = Math.max( lon_max ? lon_max : item.lon , item.lon );
                                lon_min = Math.min( lon_min ? lon_min : item.lon , item.lon );
                                lat_max = Math.max( lat_max ? lat_max : item.lat , item.lat );
                                lat_min = Math.min( lat_min ? lat_min : item.lat , item.lat );

                                objectManager.add(
                                    {
                                        type : "Feature" ,
                                        id : item.id ,
                                        geometry : {
                                            type : "Point" ,
                                            coordinates : [ item.lat , item.lon ]
                                        } ,
                                        properties : {
                                            balloonContentHeader : item.name ,
                                            balloonContentBody : `
                                            <div class="baloon-body">
                                                <div class="baloon-item">${ item.address }</div>
                                                <div class="baloon-item">${ item.workhours }</div>
                                                <div class="baloon-item baloon-item__phone">
                                                    <a
                                                        href="tel:${ String( item.phone ).substring( 0 , 1 ) == '8' ? '' : '+' }${ item.phone }"
                                                    >
                                                        ${ String( item.phone ).substring( 0 , 1 ) == '8' ? '' : '+' }
                                                        ${ String( item.phone ).substring( 0 , 1 ) }
                                                        ( ${ String( item.phone ).substring( 1 , 4 ) } )
                                                        ${ String( item.phone ).substring( 4 , 7 ) }-${ String( item.phone ).substring( 7 , 9 ) }-${ String( item.phone ).substring( 9 , 11 ) }
                                                    </a>
                                                </div>
                                            </div>
                                            ` ,
                                            balloonContentFooter : `
                                            <div class="baloon-footer">
                                                <a
                                                    class="baloon-button icon icon-detail"
                                                    href="${ item.url }"
                                                >
                                                    <span>ПОДРОБНО</span>
                                                </a>
                                                <a
                                                    class="baloon-button icon icon-route"
                                                    href="https://yandex.ru/maps/?rtext=~${ item.lat },${ item.lon }"
                                                    target="_blank"
                                                >
                                                    <span>МАРШРУТ</span>
                                                </a>
                                            </div>
                                            ` ,
                                        }
                                    }
                                );
                            }
                        )

                        myMap = new ymaps.Map(
                            view_map.value ,
                            {
                                center : [ ( lat_max + lat_min ) / 2 , ( lon_max + lon_min ) / 2 ] ,
                                zoom : 10 ,
                                controls : [ 'geolocationControl' , 'zoomControl' , 'typeSelector' , 'fullscreenControl' ]
                            }
                        );

                        myMap.geoObjects.add( objectManager );
                        applyBounds();

                    }

                    function viewObject( id ){
                        setView( 'map' );
                        myMap.setCenter( objectManager.objects.getById( id ).geometry.coordinates , 15 , { checkZoomRange : true } );
                    }

                    return {
                        contextStore ,
                        map ,
                        viewObject ,
                        setView ,
                        view_map ,
                        view_list,
                        view_mode
                    }
                }
            }
        )
            .use( createPinia() )
            .mount( el )
    }


}

document.addEventListener( "DOMContentLoaded" , initStoreListPage );
